// One message at a time, in one place, for the Fashion work screens
// (alterations, follow-ups, count): say(text, tone) replaces whatever was
// showing, so a success and an error are never on screen together. tone is
// ok | warn | bad | info. The message clears itself after a few seconds.
import React, { useCallback, useEffect, useRef, useState } from "react";

export const TOAST_MS = 3600;
export const TONES = ["ok", "warn", "bad", "info"];

export default function useFashionToast(ms = TOAST_MS) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);
  useEffect(() => () => clearTimeout(timer.current), []);
  const say = useCallback(
    (text, tone = "ok") => {
      clearTimeout(timer.current);
      if (!text) {
        setToast(null);
        return;
      }
      setToast({ text, tone: TONES.includes(tone) ? tone : "info" });
      timer.current = setTimeout(() => setToast(null), ms);
    },
    [ms]
  );
  return [toast, say];
}

// Errors and warnings are announced at once; the rest politely.
export function Toast({ toast }) {
  if (!toast) return null;
  return (
    <p className={`fp-wp-toast is-${toast.tone}`} role={toast.tone === "bad" || toast.tone === "warn" ? "alert" : "status"}>
      {toast.text}
    </p>
  );
}
